import mitt from "mitt";
import AFileControl from "./afile_control";
import LessonTool from "./toolbar/lesson_tool";
import MathTool from "./toolbar/math_tool";
import PageTool from "./toolbar/page_tool";
import PaintTool from "./toolbar/paint_tool";
import InsertTool from "./toolbar/insert_tool";
import SettingTool from "./toolbar/setting_tool";
import { focusStore } from "./store/nowFocusStore";
import SaveTool from "./toolbar/save_tool";
import ClassTool from "./toolbar/class_tool";
import ExamTool from "./toolbar/exam_tool";
import PainterProxy from "./painter/proxy";
import { store } from "../store"
import CursorStyle from "./cursor/cursor_style";
import { TOOLS } from "./toolbar/tools";
import SentenceFollowGroup from "./bookItems/sound/sentence_follow_group";
import MutualSoundAfileGroupChild from "./bookItems/mutualsoundAfile/mutual_sound_Afile_group_child";
import SentenceGroup from "./bookItems/sound/sentence_group";
export default class EventBus {

    /**
     *
     * @type {EventBus}
     * @static
     * @memberof EventBus
     */
    static instance;
    _app = null;
    _bookPage = null;
    emitter;

    /**
     *
     * @type {PageTool}
     * @memberof EventBus
     */
    pageTool = null;
    /**
     *
     * @type {PaintTool}
     * @memberof EventBus
     */
    paintTool = null;
    /**
     *
     * @type {MathTool}
     * @memberof EventBus
     */
    mathTool = null;
    /**
     *
     * @type {InsertTool}
     * @memberof EventBus
     */
    insertTool = null;
    /**
     *
     * @type {lessonTool}
     * @memberof EventBus
     */
    lessonTool = null;
    /**
     *
     * @type {PaintTool}
     * @memberof EventBus
     */
    paintTool = null;

    /**
     *
     * @type { SaveTool }
     * @memberof EventBus
     */
    saveTool = null

    /**
     *
     * @type { ClassTool }
     * @memberof EventBus
     */
    classTool = null

    /**
     *
     * @type { ExamTool }
     * @memberof EventBus
     */
    examTool = null;

    /**
     * check mouse or finger is on book page
     * @type {boolean}
     * @memberof EventBus
     */
    pointerdown = false;

    /**
     * run one time, functions on user pointer down on book page
     * @type {Array<Function>}
     * @memberof EventBus
     */
    pointerdownCallback = [];

    downPointer = {};

    constructor() {
        this.emitter = mitt();

        this.emitter.on("removeAfile", (afile) => {
            AFileControl.getInstance().removeAfile(afile);
            PainterProxy.getInstance().removeCurrentPainter();
        })
    }

    setApp(app) {
        const self = this;
        this._app = app;

        this.emitter.on("tool_box", () => {
            self.getAppRefs().toolBar.switchToolBox();
        })

        this.emitter.on("close_tool_box", () => {
            self.getAppRefs().toolBar.switchToolBox(false);
        })

        this.emitter.on("close_quick_directory", () => {
            self.getAppRefs().quickDirectory.switchQuickDirectory(false);
        })

        this.emitter.on('custom_cursor', () => {
            self.getAppRefs().cursorSetting.switchToolBox(true);
            /*
            self.getAppRefs().cursorSetting.loadSetting(
            {
                customShortcuts: {
                    0: {
                        show: true,
                        tool: "eraser",
                        toolName: "橡皮擦"
                    }
                },
                quickShortcuts: {
                    0: {
                        tool: "pen",
                        toolName: "畫筆",
                        toolValue: {
                            brushSetting: "free",
                            brushSize: "3",
                            brushType: "自由",
                            color: "黑色",
                            colorSetting: "rgba(0, 0, 0, 1)",
                            solid: "實心",
                            soildSetting: false,
                            type: "drawingPen-tool",
                            operate: 1
                        }
                    },
                    1: {
                        tool: "pen",
                        toolName: "畫筆",
                        toolValue: {
                            brushSetting: "free",
                            brushSize: "3",
                            brushType: "自由",
                            color: "黑色",
                            colorSetting: "rgba(0, 0, 0, 1)",
                            solid: "實心",
                            soildSetting: false,
                            type: "drawingPen-tool",
                            operate: 1
                        }
                    }
                }
            });
            */
        })

        this.emitter.on('load_cursor_data', (data) => {
            // console.log('+*+* load data = ', data);
            self.getAppRefs().cursorSetting.loadSetting(data);
        })

        this.emitter.on('save_cursor_data', (data) => {
            store.cursorSetting = data;
            // console.log('+*+* save data = ', data);
            /* data type
            {
                customShortcuts: {
                    0: {
                        show: true,
                        tool: "eraser",
                        toolName: "橡皮擦"
                    }
                },
                quickShortcuts: {
                    0: {
                        tool: "pen",
                        toolName: "畫筆",
                        toolValue: {
                            brushSetting: "free",
                            brushSize: "3",
                            brushType: "自由",
                            color: "黑色",
                            colorSetting: "rgba(0, 0, 0, 1)",
                            solid: "實心",
                            soildSetting: false,
                            type: "drawingPen-tool",
                            operate: 1
                        }
                    },
                    1: {
                        tool: "pen",
                        toolName: "畫筆",
                        toolValue: {
                            brushSetting: "free",
                            brushSize: "3",
                            brushType: "自由",
                            color: "黑色",
                            colorSetting: "rgba(0, 0, 0, 1)",
                            solid: "實心",
                            soildSetting: false,
                            type: "drawingPen-tool",
                            operate: 1
                        }
                    }
                }
            }
            */
        })

        this.emitter.on('set_right_menu', (data) => {
            try {
                self.getAppRefs().menuRight.setData(data);
            }
            catch (e) {
                console.log(e);
            }
        })

        this.emitter.on('set_middle_menu', (data) => {
            try {
                self.getAppRefs().menuMiddle.setData(data);
            }
            catch (e) {
                console.log(e);
            }
        })

        this.emitter.on('set_right_middle_menu', () => {
            self.getAppRefs().cursorSetting.useSetting();
        })

        this.emitter.on('painter_change_tool', (toolName) => {
            if (!toolName) {
                store.nowTool = TOOLS.SELECTION.TOOL;
            }
        })

        var uid = 0;
        var pointerUids = []
        this.emitter.on('click:object', (o) => {
            focusStore.setSelectedObject(o.target);
        })

        this.emitter.on('mouse:down:before', (o) => {
            const parent = o.e.target.parentElement;

            if (!parent) return;

            const scaleX = parent.dataset.scaleX || 1;
            const scaleY = parent.dataset.scaleY || 1;
            
            let pointer;
            if (focusStore.getNowPageItemControl().type == "mainPage") {
                pointer = { x: o.pointer.x * window.devicePixelRatio, y: o.pointer.y * store.currentBookPageScale.y * window.devicePixelRatio };
            } else {
                pointer = { x: o.pointer.x * window.devicePixelRatio * scaleX, y: o.pointer.y * window.devicePixelRatio * scaleY };
            }
            this.downPointer = {
                x: o.pointer.x,
                y: o.pointer.y,
            }
            window.createjs.Ticker.framerate = 0;
        });

        this.emitter.on('mouse:down', (o) => {
            const parent = o.e.target.parentElement;

            if (!parent) return;

            if (this.pointerdownCallback.length > 0) {
                console.log("do pointerdown callback")
                this.pointerdownCallback.forEach(element => {
                    element();
                });

                this.pointerdownCallback = [];
            }

            this.pointerdown = true;

            const scaleX = parent.dataset.scaleX || 1;
            const scaleY = parent.dataset.scaleY || 1;


            let pointer;
            if (focusStore.getNowPageItemControl().type == "mainPage") {
                pointer = { x: o.pointer.x * window.devicePixelRatio, y: o.pointer.y * store.currentBookPageScale.y * window.devicePixelRatio };
            } else {
                pointer = { x: o.pointer.x * window.devicePixelRatio * scaleX, y: o.pointer.y * window.devicePixelRatio * scaleY };
            }
            // this.downPointer = {
            //     x: o.pointer.x,
            //     y: o.pointer.y,
            // }

            if (focusStore.getNowPageItemControl().itemControl.bookItems) {
                pointerUids = [];

                focusStore.getNowPageItemControl().itemControl.bookItems.forEach(bookItem => {
                    if (bookItem.target.mouseEnabled == false) {
                        return;
                    }
                    let pt = bookItem.target.globalToLocal(pointer.x, pointer.y);
                    if (bookItem.target.hitTest(pt.x, pt.y)) {
                        if (bookItem.target.visible) {
                            uid = bookItem.target.id;
                            pointerUids.push(uid);
                            bookItem.target.dispatchEvent(new CustomEvent('mousedown'));
                            return;
                        }
                    }
                });

                // console.log("mousedown::", pointerUids);
            }
        })

        this.emitter.on('mouse:up', (o) => {
            const parent = o.e.target.parentElement;

            window.createjs.Ticker.framerate = 24;

            if (!parent) return;
            this.pointerdown = false;

            const scaleX = parent.dataset.scaleX || 1;
            const scaleY = parent.dataset.scaleY || 1;
            let pointer;
            if (focusStore.getNowPageItemControl().type == "mainPage") {
                pointer = { x: o.pointer.x * window.devicePixelRatio, y: o.pointer.y * store.currentBookPageScale.y * window.devicePixelRatio };
            } else {
                pointer = { x: o.pointer.x * window.devicePixelRatio * scaleX, y: o.pointer.y * window.devicePixelRatio * scaleY };
            }
            const distanceX = this.downPointer.x - o.pointer.x;
            const distanceY = this.downPointer.y - o.pointer.y;
            // console.log(`move distance:: ${(distanceX * distanceX + distanceY * distanceY)}`)
            // 代表移動過
            if ((distanceX * distanceX + distanceY * distanceY) > 25) {
                console.log("because mouse move, so no trigger button")
                return;
            }
            const mouseOverItems = [];
            if (focusStore.getNowPageItemControl().itemControl.bookItems) {
                console.log(">>>>>", focusStore.getNowPageItemControl().itemControl.bookItems)
                focusStore.getNowPageItemControl().itemControl.bookItems.forEach(bookItem => {
                    if (bookItem.target.mouseEnabled == false) {
                        return;
                    }
                    let pt = bookItem.target.globalToLocal(pointer.x, pointer.y);
                    if (bookItem.target.hitTest(pt.x, pt.y)) {
                        if (bookItem.target.visible) {
                            if (pointerUids.includes(bookItem.target.id)) {
                                if (!(bookItem instanceof SentenceGroup) &&
                                    !(bookItem instanceof SentenceFollowGroup) &&
                                    !(bookItem instanceof MutualSoundAfileGroupChild)) {
                                    mouseOverItems.push(bookItem);
                                }
                            }
                            bookItem.target.dispatchEvent(new CustomEvent('mouseup'));
                            return;
                        }
                    }
                });

                if(mouseOverItems.length > 0) {
                    console.log("click:::", mouseOverItems);
                    mouseOverItems[0].target.dispatchEvent(new CustomEvent('click'));
                }
            }
        })

        this.emitter.on('mouse:move', (o) => {
            const parent = o.e.target.parentElement;

            if (!parent) return;

            // console.log("framerate::", window.createjs.Ticker.framerate);

            const scaleX = parent.dataset.scaleX || 1;
            const scaleY = parent.dataset.scaleY || 1;
            let pointer;
            if (focusStore.getNowPageItemControl().type == "mainPage") {
                pointer = { x: o.pointer.x * window.devicePixelRatio, y: o.pointer.y * window.devicePixelRatio };
            } else {
                pointer = { x: o.pointer.x * window.devicePixelRatio * scaleX, y: o.pointer.y * window.devicePixelRatio * scaleY };
            }

            let mouseover = false;
            const mouseOverItems = [];
            if (focusStore.getNowPageItemControl().itemControl.bookItems) {
                for(let bookItem of focusStore.getNowPageItemControl().itemControl.bookItems) {
                // focusStore.getNowPageItemControl().itemControl.bookItems.forEach(bookItem => {
                    if(this.pointerdown) {
                        console.log("stop check items");
                        return;
                    }
                    if (bookItem.target.mouseEnabled == false) {
                        continue;
                    }

                    // 如果組件沒有mouseover或mouseout的event，就不用去檢查監聽，這部分是為了降低耗能
                    if (bookItem.target.id !== uid && (!bookItem.target.hasEventListener("mouseout") || !bookItem.target.hasEventListener("mouseover"))) {
                        continue;
                    }

                    let pt = bookItem.target.globalToLocal(pointer.x, pointer.y);
                    if (bookItem.target.hitTest(pt.x, pt.y) && bookItem.target.visible && bookItem.target.mouseEnabled) {
                        if (!(bookItem instanceof SentenceGroup) &&
                            !(bookItem instanceof SentenceFollowGroup) &&
                            !(bookItem instanceof MutualSoundAfileGroupChild)) {
                            mouseOverItems.push(bookItem);
                            mouseover = true;
                        }
                    } else {
                        if (bookItem.target.id == uid) {
                            console.log("mouse move and uid reset")
                            uid = 0;
                        }
                        bookItem.target.dispatchEvent(new CustomEvent('mouseout'));
                    }
                };
                if(mouseOverItems.length > 0) {
                    // console.log("mouse over:::", mouseOverItems);
                    mouseOverItems[0].target.dispatchEvent(new CustomEvent('mouseover'));
                }

                if (mouseover) {
                    CursorStyle.getInstance().setCursorPointer(true);
                } else {
                    CursorStyle.getInstance().setCurrentCursor();
                }
                return;
            } else {
                CursorStyle.getInstance().setCurrentCursor();
            }
        })

        this.pageTool = new PageTool(
            this.getAppRefs().bookPage,
            this.getAppRefs().exitDialog
        );
        const pageToolFunctions = this.pageTool.getToolFunction();

        this.paintTool = new PaintTool(this.getAppRefs().confirmDialog);
        const paintToolFunctions = this.paintTool.getToolFunction();

        this.mathTool = new MathTool(this.getAppRefs().summaryGraph);
        const mathToolFunctions = this.mathTool.getToolFunction();

        this.insertTool = new InsertTool();
        const insertToolFunctions = this.insertTool.getToolFunction();

        this.lessonTool = new LessonTool();
        const lessonToolFunctions = this.lessonTool.getToolFunction();

        this.settingTool = new SettingTool(
            this.getAppRefs().pageTags,
            this.getAppRefs().setting,
            this.getAppRefs().toolBar,
            this.getAppRefs().confirmDialog
        );
        const settingToolFunctions = this.settingTool.getToolFunction();

        this.saveTool = new SaveTool(
            this.getAppRefs().promptDialog,
            this.getAppRefs().confirmDialog,
            this.getAppRefs().alertDialog,
            this.getAppRefs().saveDialog,
            this.getAppRefs().userRecord,
            this.getAppRefs().loginType,
            this.getAppRefs().mergeConfirm,
            this.getAppRefs().messageDialog
        );
        const saveToolFunctions = this.saveTool.getToolFunction();

        this.classTool = new ClassTool();
        const classToolFunctions = this.classTool.getToolFunction();

        this.examTool = new ExamTool(this.getAppRefs().lessonExamSelector, this.getAppRefs().lessonExamTip);
        const examToolFunctions = this.examTool.getToolFunction();

        pageToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        paintToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        mathToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        lessonToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        insertToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        settingToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        saveToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        classToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

        examToolFunctions.forEach(element => {
            self.emitter.on(element.key, element.event);
        });

    }

    getAppRefs() {
        return this._app.$refs;
    }

    static getInstance() {
        if (this.instance == null) {
            this.instance = new EventBus();
        }

        return this.instance;
    }

    /**
     * @param {string} type
     * @param {unknown} event
     * @memberof EventBus
     */
    emit(type, event) {
        //console.log(type)
        this.emitter.emit(type, event);
    }

    setBookPage(bookPage) {
        this._bookPage = bookPage;
    }
}